import { Component } from '@angular/core';

@Component({
  selector: 'app-update-socialhistory',
  templateUrl: './update-socialhistory.component.html',
  styleUrls: ['./update-socialhistory.component.css']
})
export class UpdateSocialhistoryComponent {

}
